// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"f66d5124","457":"c67c4366","488":"87b9d18a","551":"03885098","796":"999856f5","828":"e97b4043","851":"55c5da0e"}[chunkId] + ".chunk.js";
};